import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import arrow_back from '../assets/images/arrow-back.svg';
import ProfileHeader from '../components/ProfileHeader';
import AddRelatedPersonForm from '../components/AddRelatedPersonForm';
import EDSFooter from '../components/EDSFooter';

const Osoba_powiazana_dodaj = () => {
    const history = useHistory();

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <div>
                    <a href="">
                        <Link to="/wybor_opcji_1_uczestnik">
                            <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                        </Link>
                    </a>
                </div>
                <ProfileHeader></ProfileHeader>
                <div className="margin-top-32">
                    <AddRelatedPersonForm
                        finished={(response) => {
                           
                            localStorage.setItem(
                                'addedSubAccountFullName',
                                response.personData.firstName + ' ' + response.personData.lastName
                            );

                            if (response.confirmationNeeded) {
                                history.push('/osoba_powiazana_potwierdz');
                            } else {
                                history.push('/osoba_powiazana_dodano');
                            }
                        }}
                    ></AddRelatedPersonForm>
                </div>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Osoba_powiazana_dodaj;
